import { useEffect, useState } from 'react'
import { ensureRecognitionModelsLoaded } from '../utils/faceRecognition'

export function useFaceApiModels() {
    const [modelsLoaded, setModelsLoaded] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        let active = true
        ensureRecognitionModelsLoaded()
            .then(() => active && setModelsLoaded(true))
            .catch(err => active && setError(err.message || 'Failed to load face models'))
        return () => { active = false }
    }, [])

    return { modelsLoaded, error }
}